import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const TOKEN_KEY = "tdf_admin_token";

const AdminAuthContext = createContext(null);

export function useAdminAuth() { return useContext(AdminAuthContext); }

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const apiClient = useCallback(() => {
    return axios.create({
      baseURL: API,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  }, [token]);

  useEffect(() => {
    if (!token) { setMe(null); setLoading(false); return; }
    apiClient().get("/admin/me")
      .then((r) => setMe(r.data))
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setToken(""); setMe(null); })
      .finally(() => setLoading(false));
  }, [token, apiClient]);

  const login = useCallback(async (email, password) => {
    const res = await axios.post(`${API}/admin/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    setToken(res.data.token);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
    setMe(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ token, me, loading, login, logout, apiClient }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
